export default {
  setInputValue: (payload: string) =>
    <const>{
      type: 'SET_INPUT_VALUE',
      payload,
    },
  clearInputValue: () =>
    <const>{
      type: 'CLEAR_INPUT_VALUE',
    },
  setAutoCompleting: (payload: boolean) =>
    <const>{
      type: 'SET_AUTOCOMPLETING',
      payload,
    },
};
